"use client";

import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "skedyul:preferredModelId";

export interface ModelPreference {
  preferredModelId: string | null;
  setPreferredModelId: (modelId: string) => void;
  isLoaded: boolean;
}

/**
 * Hook to manage user's preferred LLM model selection via localStorage.
 * Persists the user's model choice across sessions.
 */
export function useModelPreference(): ModelPreference {
  const [preferredModelId, setPreferredModelIdState] = useState<string | null>(
    null,
  );
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setPreferredModelIdState(stored);
      }
    } catch {
      // localStorage may not be available (SSR, private browsing, etc.)
    }
    setIsLoaded(true);
  }, []);

  const setPreferredModelId = useCallback((modelId: string) => {
    try {
      localStorage.setItem(STORAGE_KEY, modelId);
      setPreferredModelIdState(modelId);
    } catch {
      // localStorage may not be available
    }
  }, []);

  return {
    preferredModelId,
    setPreferredModelId,
    isLoaded,
  };
}
